import React from "react";

import {MuiIcon, MuiIconExternalProps} from './MuiIcon';

export const ZoomInIcon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\ue8ff'}</MuiIcon>
        );
    }
)